const faqItems = [
  {
    q: '被窝网电影需要注册或付费吗？',
    a: '不需要。被窝网电影所有影视资源完全免费在线观看，无需注册、无需登录、无需付费，打开网站即可畅享高清观影体验。',
  },
  {
    q: '为什么叫"被窝网"？和其他影视站有什么不同？',
    a: '因为最好的观影姿势就是窝在被窝里！被窝网电影以"舒适观影"为核心理念，专注片源质量与播放流畅度，不做弹窗广告、不强制跳转，给你纯粹干净的观影环境。',
  },
  {
    q: '视频加载慢或卡顿怎么办？',
    a: '被窝网电影采用多线路智能调度技术，自动匹配最优播放节点。如遇卡顿，建议切换播放线路或检查本地网络。我们承诺 99.9% 的片源无需缓冲即可流畅播放。',
  },
  {
    q: '网站多久更新一次片源？',
    a: '被窝网电影实行每日凌晨自动更新机制，院线新片下映后最快 48 小时内上线高清版，电视剧同步卫视播出进度，综艺和动漫每周定时更新，确保你不错过任何精彩。',
  },
  {
    q: '可以在手机或平板上观看吗？',
    a: '当然可以！被窝网电影全面适配手机、平板和电脑端，无需下载 App，浏览器打开即可享受高清流畅播放，横竖屏自动适配，随时随地窝着看。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-accent-600 tracking-widest uppercase mb-2">FAQ</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            关于被窝网电影，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60">
              <h3 className="text-base font-semibold text-foreground-900 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}